import React, { BaseSyntheticEvent, useContext } from "react";
import { useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { DashboardContext } from "../../../../contexts/Dashboard/DashboardContext";

const Title = () => {
  const { titlePage, changeTitle } = useContext(DashboardContext);
  const { mode } = useParams();

  const onChangeForm = (event: BaseSyntheticEvent) => {
    changeTitle({ title: event.target.value });
  };

  return (
    <>
      {mode === "edit" ? (
        <Form.Control
          placeholder="Insira um título"
          defaultValue={titlePage}
          onChange={onChangeForm}
        />
      ) : (
        <h2>{titlePage}</h2>
      )}
    </>
  );
};

export default Title;
